"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_broadband__device__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ff3edb19-21f8-4821-a07b-e9491003ae9b",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a2d9d06e-4b31-4511-aaaa-8825a8cb2011,.b5246487-7f61-4ba2-a0d1-ee7abdded6cb{fill:none;}.ea230647-7fa9-401a-b598-f786ae1f75ba{fill:#fff;}.a51da3d1-c919-476b-9dc9-c633b9328647{fill:#4a4d4e;}.b5246487-7f61-4ba2-a0d1-ee7abdded6cb{stroke:#e60000;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}.e7d327f2-496c-49f4-9d0f-3cbd984e96bb{opacity:0.06;isolation:isolate;}")), /*#__PURE__*/React.createElement("title", null, "broadband-device-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "f0987e2d-cb1b-42ca-b9bf-0db1d943ee81",
    "data-name": "c8eba312-18a9-4286-a10b-eac1e94d8dab"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bafb5fd0-8b1e-42bc-866f-e7784b9172d0",
    "data-name": "c789b18c-1480-4dba-8a35-8cf8ffaf76fd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a7436fbd-456c-42ba-8ba5-e3b1110417e4",
    "data-name": "a1b5e78a-be1b-4787-9d88-128674dc2509"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a2d9d06e-4b31-4511-aaaa-8825a8cb2011",
    width: 192,
    height: 192
  }), /*#__PURE__*/React.createElement("path", {
    className: "ea230647-7fa9-401a-b598-f786ae1f75ba",
    d: "M96,16h0a80,80,0,0,1,80,80h0a80,80,0,0,1-80,80h0A80,80,0,0,1,16,96h0A80,80,0,0,1,96,16Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "afa92505-7c69-4e90-916b-9fd14633e101",
    "data-name": "b983d9c8-fcb7-4efe-a146-504ba406c387"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "bdeacb0c-71bd-4764-b591-4425abbb6523",
    "data-name": "e01f1846-d70c-4681-a1f8-39080db87e0b",
    className: "a51da3d1-c919-476b-9dc9-c633b9328647",
    cx: 96,
    cy: 118,
    r: 8
  })), /*#__PURE__*/React.createElement("path", {
    id: "a86e46b7-b0b2-49fd-aeea-0698ecd13900",
    "data-name": "ae0656b9-99ba-473c-881c-fbe39020c813",
    className: "b5246487-7f61-4ba2-a0d1-ee7abdded6cb",
    d: "M54.17,79.37a59.13,59.13,0,0,1,83.62,0l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a8f1266c-a865-4fc3-8a60-4d15780c7583",
    "data-name": "b2add571-1a18-41c0-8cae-b61162d79878",
    className: "b5246487-7f61-4ba2-a0d1-ee7abdded6cb",
    d: "M66.28,90A42.25,42.25,0,0,1,126,90l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b5246487-7f61-4ba2-a0d1-ee7abdded6cb",
    d: "M78.72,99.18a24.58,24.58,0,0,1,34.73,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e7d327f2-496c-49f4-9d0f-3cbd984e96bb",
    d: "M96,174h0A80.23,80.23,0,0,1,16,95v1h0a80.24,80.24,0,0,0,80,80h0a80.24,80.24,0,0,0,80-80h0V95A80.23,80.23,0,0,1,96,174Z"
  })))));
}

var _default = ic_broadband__device__dark;
exports.default = _default;